<template>
  <g
    class="tag"
    :transform="'translate(' + pointPos.x + ' ' + pointPos.y + ')'"
    v-on:mouseover="hover = true"
    v-on:mouseout="hover = false"
  >
    <g
      :transform="'scale(' + pointZoom + ')'"
      v-if="activeOpacity != 1"
      class="tag-circle"
    >
      <circle id="Ellipse_35" cx="-1.5" cy="1.5" r="19.1" fill="#888888" />
      <circle id="Ellipse_36" cx="1.5" cy="-1.5" r="19.1" fill="#E9993E" />
      <circle id="Ellipse_37" cx="0" cy="0" r="19.1" fill="#eeedee" />
    </g>
    <g
      clip-path="url(#clip-path)"
      :transform="'scale(' + pointZoom + ')'"
      :opacity="activeOpacity"
      class="tag-circle"
    >
      <circle id="Ellipse_32" cx="-2.4" cy="1.5" r="19.1" fill="#888888" />
      <circle id="Ellipse_33" cx="0.7" cy="-1.6" r="19.1" fill="#E9993E" />
      <circle id="Ellipse_34" cx="-0.8" cy="0" r="19.1" fill="#E9993E" />
      <circle
        id="Ellipse_34"
        cx="-0.8"
        cy="0"
        r="19.1"
        fill="#eeedee"
        :opacity="zoomNum"
      />
    </g>
    <g
      clip-path="url(#clip-path-2)"
      :transform="'scale(' + pointZoom + ')'"
      :opacity="activeOpacity"
      class="tag-circle"
    >
      <circle id="Ellipse_35" cx="-1.5" cy="1.5" r="19.1" fill="#888888" />
      <circle id="Ellipse_36" cx="1.5" cy="-1.5" r="19.1" fill="#E9993E" />
      <circle id="Ellipse_37" cx="0" cy="0" r="19.1" fill="#eeedee" />
    </g>
    <g
      :transform="'rotate(' + rotation + ')'"
      transform-origin="0 0"
      :opacity="outTextOpacity"
    >
      <line
        x1="0"
        y1="0"
        :x2="lineLen"
        y2="0"
        fill="none"
        stroke="#E9993E"
        stroke-width="1"
      />
      <text
        :x="length || 215"
        y="5"
        font-size="14"
        fill="#E9993E"
        font-family="Helvetica-Light, Helvetica"
        :transform="`translate(${length || 215} 5) rotate(20) translate(-${
          length || 215
        } -5)`"
        :opacity="textOpacity"
        font-weight="300"
        >{{ title.toUpperCase() }}</text
      >
    </g>
    <g :opacity="zoomNum" class="tag-circle">
      <text
        x="0"
        y="0"
        font-size="3.6666"
        fill="black"
        dominant-baseline="middle"
        text-anchor="middle"
        font-family="Helvetica-Light, Helvetica"
        font-weight="300"
        >{{ title }}</text
      >
      <circle
        cx="0"
        cy="0"
        r="24"
        stroke="#666666"
        stroke-width="0.333"
        fill="none"
      />
      <g v-for="(spoint, si) in sub" class="spointg" v-on:click.stop="">
        <circle :cx="spX(spoint.p)" :cy="spY(spoint.p)" r="2" />
        <text
          :x="spX(spoint.p) + (leftP(spoint.p) ? -3 : 3)"
          :y="spY(spoint.p)"
          font-family="Helvetica-Light, Helvetica"
          font-weight="300"
          font-size="1.8"
          dominant-baseline="middle"
          :text-anchor="leftP(spoint.p) ? 'end' : 'start'"
          >{{ spoint.title.toUpperCase() }}</text
        >
      </g>
    </g>
  </g>
</template>

<script>
export default {
  props: [
    'pos',
    'rotation',
    'title',
    'sub',
    'progress',
    'zoom',
    'progress2',
    'length',
  ],
  data: () => ({
    hover: false,
    hoverNum: 0,
    zoomNum: 0,
    rotation2: 0,
  }),
  watch: {
    hover() {
      clearInterval(this.hoverInverval);
      this.hoverInverval = setInterval(() => {
        this.hoverNum += this.hover ? 0.05 : -0.05;
        if (this.hover && this.hoverNum >= 1) {
          this.hoverNum = 1;
          clearInterval(this.hoverInverval);
        }
        if (!this.hover && this.hoverNum <= 0) {
          this.hoverNum = 0;
          clearInterval(this.hoverInverval);
        }
      }, 16);
    },
    zoom() {
      clearInterval(this.zoomInterval);
      this.zoomInterval = setInterval(() => {
        this.zoomNum += this.zoom ? 0.05 : -0.05;
        if (this.zoom && this.zoomNum >= 1) {
          this.zoomNum = 1;
          clearInterval(this.zoomInterval);
        }
        if (!this.zoom && this.zoomNum <= 0) {
          this.zoomNum = 0;
          clearInterval(this.zoomInterval);
        }
      }, 16);
      if (!this.zoom) {
        clearInterval(this.zoomRotation);
      } else {
        this.zoomRotation = setInterval(() => {
          this.rotation2 += 0.1;
        }, 16);
      }
    },
  },
  computed: {
    outTextOpacity() {
      return Math.min(this.activeOpacity, 1 - this.zoomNum);
    },
    activeOpacity() {
      var progress = Math.min(4, Math.max(0, Math.abs(this.progress2) - 4));
      progress = Math.max(1 - progress / 4, this.hoverNum, this.zoomNum);
      return progress;
    },
    pointPos() {
      return this.$parent.pointAtProgress(this.pos);
    },
    pointZoom() {
      return Math.min(1, Math.max(0, (this.progress + 5) / 5));
    },
    lineLen() {
      return (
        Math.min(1, Math.max(0, (this.progress2 + 1) / 1.5)) *
        ((this.length || 215) - 5)
      );
    },
    textOpacity() {
      return Math.min(1, Math.max(0, (this.progress2 + 1) / 1.5));
    },
  },
  methods: {
    spX(p) {
      return Math.cos(((this.rotation2 + p) / 180) * Math.PI) * 24;
    },
    spY(p) {
      return Math.sin(((this.rotation2 + p) / 180) * Math.PI) * 24;
    },
    leftP(p) {
      return (
        (this.rotation2 + p) % 360 > 90 && (this.rotation2 + p) % 360 < 270
      );
    },
  },
};
</script>
